import { render, staticRenderFns } from "./MicroMenu.vue?vue&type=template&id=73d14c13&"
import script from "./MicroMenu.vue?vue&type=script&lang=js&"
export * from "./MicroMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports